import { Cart, CartItem } from "../../contexts/cart/types";
import { useEffect, useState } from "react";
import * as React from "react";
import { RequestParams, useRequest } from "../use-request";

const API_URL = `/api/get-cart-discount`;

type DiscountMap = { [concatString: string]: number };
type DiscountMapResponse = { data: DiscountMap };

export interface CartDiscountInterface {
  cartDiscountItems: DiscountMap;
  totalCartDiscount: number;
  fetchTotalCartDiscount: React.Dispatch<Array<CartItem>>;
  isLoading: boolean;
  error?: string;
}

interface Params {
  lineItems?: Array<CartItem>;
}

export const useCartDiscount = (cart: Cart): CartDiscountInterface => {
  const [totalCartDiscount, setTotalCartDiscount] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>(undefined);
  const [discountItems, setDiscountItems] = useState<DiscountMap>();

  const [requestParams, setRequestParams] = useState<RequestParams>(
    createRequestParams({ lineItems: cart?.lineItems })
  );

  const cartDiscountRequest = useRequest<DiscountMapResponse>(requestParams);

  useEffect(() => {
    if (cart && cartDiscountRequest.data && cartDiscountRequest.isSuccess) {
      const { data: discountMap } = cartDiscountRequest.data;
      const totalDiscount = cart?.lineItems?.reduce((acc, item) => {
        return (
          !item.hideRRP &&
          acc +
            (discountMap[item.productId + "-" + item.name] || 0) * item.quantity
        );
      }, 0);
      setTotalCartDiscount(totalDiscount);
      setDiscountItems(discountMap);
    }
  }, [cartDiscountRequest.data, cart?.lineItems]);

  useEffect(() => {
    setIsLoading(cartDiscountRequest.isLoading && !cartDiscountRequest.error);
  }, [cartDiscountRequest.isLoading, cartDiscountRequest.error]);

  useEffect(() => {
    setError("Failed to fetch order history");
  }, [cartDiscountRequest.error]);

  return {
    cartDiscountItems: discountItems,
    totalCartDiscount,
    isLoading,
    error,
    fetchTotalCartDiscount: (lineItems: Array<CartItem>) => {
      setRequestParams(createRequestParams({ lineItems }));
    },
  };
};

const createRequestParams = ({ lineItems = [] }: Params): RequestParams => {
  const bigCommerceIds = lineItems
    ?.map((item) => item.productId)
    ?.filter(Boolean);
  const productNames = lineItems?.map((item) => item.name)?.filter(Boolean);
  if (!bigCommerceIds || bigCommerceIds.length === 0) {
    return { url: "", queryStringParams: {} };
  }

  return {
    url: API_URL,
    queryStringParams: {
      bigCommerceIds: JSON.stringify(bigCommerceIds?.filter(Boolean)),
      productNames: JSON.stringify(productNames?.filter(Boolean)),
    },
  };
};
